// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ControlTwoToneSvg from "@fishx/icons-svg/es/asn/ControlTwoTone";
import FishxIcon from '../components/FishxIcon';

var ControlTwoTone = function ControlTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ControlTwoToneSvg
  }));
};

ControlTwoTone.displayName = 'ControlTwoTone';
export default React.forwardRef(ControlTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ControlTwoTone.js
// module id = 2319
// module chunks = 0